import { Widget } from '../../../apiService';
import PromotedCardList from '../../../PromotedCardList';

const PromotedWidget = ({ widget }: { widget: Widget<'promoted'> }) => {
  const {
    configuration: { items },
  } = widget;

  return <PromotedCardList items={items} title={widget.display_title} />;
};

export default PromotedWidget;
